import { useEffect, useState } from 'react';
import { Appointment } from '../../../domain/entities';
import { useAppointmentService, useUserService } from '../../hooks';
import SidebarLayout from '../../layouts/SidebarLayout';
import DoctorAppointmentCard from './components/DoctorAppointmentCard/DoctorAppointmentCard';
import MedicalAppointmentRow from './components/DoctorAppointmentRow/MedicalAppointmentRow';
import { loaderActions } from '../../store/loader';
import { useDispatch } from 'react-redux';

const MedicalAppointmentList = () => {
  const UserService = useUserService();
  const AppointmentService = useAppointmentService();
  const dispatch = useDispatch();

  const [appointments, setAppointments] = useState<Appointment[]>([]);

  const isLoading = (state: boolean) => {
    dispatch(loaderActions.setLoading(state));
  };

  useEffect(() => {
    isLoading(true);

    const doctorId = UserService.getUser().id;
    AppointmentService.listByDoctor(doctorId, true)
      .then((data) => setAppointments(data))
      .catch((e) => console.log(e))
      .finally(() => isLoading(false));
  }, []);

  if (appointments.length <= 0) {
    return (
      <SidebarLayout>
        <div />
      </SidebarLayout>
    );
  }

  return (
    <SidebarLayout>
      <h2>Siguiente consulta:</h2>
      <DoctorAppointmentCard appointment={appointments[0]} style={{ margin: 'auto' }} />
      <h2>Próximas consultas:</h2>
      {appointments.map((appointment) => (
        <MedicalAppointmentRow key={appointment.id} appointment={appointment} />
      ))}
    </SidebarLayout>
  );
};

export default MedicalAppointmentList;
